angular.module('impactx.bank').controller('BankCtrl', BankCtrl);
BankCtrl.$inject = ['$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$routeParams',
    'ToolbarService'
];

function BankCtrl($scope, dataGen, BackService, $mdToast, ConfirmationService, $routeParams, ToolbarService) {
    var bankId = $routeParams.id;
    var ctrl = this;

    this.save = function () {
        var dataObj = {
            bank: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/bank/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };
    this.delete = function () {
        var dataObj = {
            id: $scope.data.bankId
        };
        dataGen.postAsForm($scope, dataObj, "/bank/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    dataGen.getData($scope, {id: bankId}, "/bank/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: isEditable
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}